import React, { useEffect, useState, useRef, useCallback } from "react";
import { io } from 'socket.io-client';
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Link } from "react-router-dom";
import { Dropdown, Row, Col, Nav, Form, Modal, Button } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import Avatar from "../components/Avatar";
import moment from 'moment';
import ringSound from '../../src/assets/ring.mp3';

import { patientname,generateMediaRoomId, 
  parseAvatar, } from "../utils/chat/utils";

  import { 
    markMessageAsRead,
    connectMediaSocket, 
    disconnectMediaSocket,
    getRecentMediaChats,
    getChatHistoryByPatient,
    sendMediaMessage,subscribeMediaIO,
    getMediaSocket, 
    Register} from "../utils/chat/telemedicineSockets";
import useProfileStore from "../store/patient/profileStore";


const Chat = () => {
  const { profile } = useProfileStore();
  const bottomRef = useRef(null);
  // const callStartTime = useRef(null);

  const [callStartTime, setCallStartTime] = useState(null);
  const [activeUser, setActiveUser] = useState(null);
  const [showChat, setShowChat] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [callStatus, setCallStatus] = useState("");
  const [messages, setMessages] = useState([]);
  const [recentChats, setRecentChats] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const [messageInput, setMessageInput] = useState("");
  const [callRequestData, setCallRequestData] = useState(null);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [showCallRequestModal, setShowCallRequestModal] = useState(false);
  const [allMessages, setAllMessages] = useState({});
  const activeUserRef = useRef(null);


  const token = localStorage.getItem('token')
  // Initialize socket connection
  const user =  JSON.stringify(profile?.id)
  useEffect(() => {
    if (profile?.id) {
      connectMediaSocket(user, token);
      fetchRecentChats();
      subscribeMediaIO(handleCallRequest, handleCallCancelled);
      Register({ userId: JSON.stringify(profile?.id) });
      
      // Add message listener
      const socket = getMediaSocket();
      if (socket) {
        socket.on('private-message', handleIncomingMessage);
      }
      
      return () => {
        disconnectMediaSocket();
        if (socket) {
          socket.off('private-message', handleIncomingMessage);
        }
      };
    }
  }, [profile]);

  // Fetch recent chats
  const fetchRecentChats = () => {
    if (!profile?.id) return;
    
    getRecentMediaChats({ doctorId: user, token }, (chats) => {
      setRecentChats(chats.map(chat => ({
        id: chat.doctorId,
        patient: chat.patient,
        doctor:chat.doctor,
        lastMessage: chat.lastMessage,
        timestamp: chat.lastMessageTime,
        unreadCount: chat.unreadCount
      })));
    });
  };

    // Handle incoming call request
    const handleCallRequest = useCallback((data) => {
      setCallRequestData(data);
      setShowCallRequestModal(true);
      // Optional: Play a notification sound
      const audio = new Audio(ringSound);
      // audio.loop = true; 
      audio.play().catch((err) => {
        console.error("Failed to play audio:", err);
      });
    }, []);

  // Handle call cancelled (initiator cancelled or answered on another device)
  const handleCallCancelled = useCallback((data) => {
    setShowCallRequestModal(false);
    setCallRequestData(null);
  }, []);

      // Handle accepting a call
  const handleAcceptCall = useCallback(() => {
    if (!callRequestData) return;
    setShowCallRequestModal(false);
    setShowVideoModal(true);
    setCallStatus("calling");
    // callStartTime = Date.now();
    const socket = getMediaSocket();
    if (socket) {
        socket.emit('accept-call', {
        roomId: callRequestData.roomId,
        // fromId: callRequestData.fromId,
        // toId: profile?.id
        userId: JSON.stringify(profile?.id),
      });
    }
  }, [callRequestData, profile]);


  // Handle rejecting a call
  const handleRejectCall = useCallback(() => {
    if (!callRequestData) return;
    setShowCallRequestModal(false);
    const socket = getMediaSocket();
    if (socket) {
      socket.emit('call-rejected', {
        roomId: callRequestData.roomId,
        // fromId: callRequestData.fromId,
        // toId: profile?.id
        userId:JSON.stringify(profile?.id),
      });
    }
    setCallRequestData(null);
  }, [callRequestData, profile]);



  // const handleIncomingMessage = useCallback((data) => {
  //   // Check if message belongs to current active chat
  //   if (activeUser && 
  //       (data.fromUserId == activeUser.id || data.fromUserId == JSON.stringify(profile?.id))) {
  //     const newMessage = {
  //       message: data.message,
  //       from: data.fromUserId,
  //       to: data.toUserId,
  //       timestamp: data.timestamp || new Date().toISOString()
  //     };
      
  //     setMessages(prev => [...prev, newMessage]);
      
  //     // Scroll to bottom
  //     setTimeout(() => {
  //       if (bottomRef.current) {
  //         bottomRef.current.scrollIntoView({ behavior: 'smooth' });
  //       }
  //     }, 100);
      
  //     // Mark as read if we're the recipient
  //     if (data.fromUserId === activeUser.id) {
  //       markMessageAsRead({ 
  //         fromUserId: activeUser.id, 
  //         toUserId: JSON.stringify(profile?.id) 
  //       });
  //     }
  //   }
    
  //   // Always update recent chats when new message arrives
  //   fetchRecentChats();
  // }, [activeUser, profile?.id]);
  

  // Handle user selection
 
  const handleIncomingMessage = useCallback((data) => {
    const fromUserId = data.fromUserId;
    const toUserId = data.toUserId;
    const currentUserId = JSON.stringify(profile?.id);
    const isToCurrentUser = toUserId === currentUserId;
  
    const message = {
      message: data.message,
      from: fromUserId,
      to: toUserId,
      timestamp: data.timestamp || new Date().toISOString(),
    };
  
    // Agent messages are aggregated under the synthetic "support" channel on
    // the server, so map them to that conversation id instead of the raw agent id.
    // Otherwise normalize to strings — server ids are strings, local ids may be numbers.
    const senderId =
      data.senderType === "staff" || data.senderType === "agent" || data.senderType === "doctor"
        ? "support"
        : String(fromUserId === currentUserId ? toUserId : fromUserId);

    // Store the message for the conversation partner
    setAllMessages(prev => ({
      ...prev,
      [senderId]: [...(prev[senderId] || []), message]
    }));

    // Only update current visible messages if this chat is open (loose id compare)
    if (String(activeUserRef.current?.id) === senderId) {
      setMessages(prev => [...prev, message]);

      setTimeout(() => {
        if (bottomRef.current) {
          bottomRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }

    fetchRecentChats();
  }, [profile?.id]);
  

  const handleUserSelect = useCallback((user) => {
    setActiveUser(user);
    activeUserRef.current = user;
    setShowChat(true);
    setLoadingMessages(true);
  
    const userId = user.id;
    const patientId = JSON.stringify(profile?.id);
  
    getChatHistoryByPatient({ doctorId: userId, patientId }, (msgsFromServer) => {
      const formatted = msgsFromServer.map(msg => ({
        message: msg.message,
        from: msg.fromUserId,
        to: msg.toUserId,
        timestamp: msg.createdAt
      }));
  
      // Merge server messages + any incoming ones received via socket
      setMessages([
        ...formatted,
        ...(allMessages[userId] || []).filter(
          m => !formatted.some(f => f.timestamp === m.timestamp)
        )
      ]);
  
      setLoadingMessages(false);
  
      markMessageAsRead({
        fromUserId: userId,
        toUserId: patientId
      });
  
      setTimeout(() => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    });
  }, [profile, allMessages]);  
 
  // const handleUserSelect = useCallback((user) => {
  //   setActiveUser(user);
  //   setShowChat(true);
  //   setLoadingMessages(true);
  //   console.log(user)
    
  //   if (profile?.id && user?.id) {
  //     getChatHistoryByPatient(
  //       { doctorId: user.id, patientId: JSON.stringify(profile?.id),},
  //       (messages) => {
  //         const formattedMessages = messages.map(msg => ({
  //           message: msg.message,
  //           from: msg.fromUserId,
  //           to: msg.toUserId,
  //           timestamp: msg.createdAt
  //         }));
  //         setMessages(formattedMessages);
  //         setLoadingMessages(false);
          
  //         // Mark messages as read
  //         markMessageAsRead({ 
  //           fromUserId: user?.id , 
  //           toUserId: JSON.stringify(profile?.id) 
  //         });

  //         // Scroll to bottom after loading
  //         setTimeout(() => {
  //           if (bottomRef.current) {
  //             bottomRef.current.scrollIntoView({ behavior: 'smooth' });
  //           }
  //         }, 100);
  //       }
  //     );
  //   }
  // }, [profile]);

  // Handle sending a message
  // const handleSendMessage = (e) => {
  //   e.preventDefault();
    
  //   if (!messageInput.trim() || !activeUser || !profile?.id) return;

  //   const roomId = generateMediaRoomId({ 
  //     patientId: profile.id, 
  //     doctorId: activeUser.id 
  //   });

  //   const newMessage = {
  //     message: messageInput.trim(),
  //     from: profile.id,
  //     to: activeUser.id,
  //     timestamp: new Date().toISOString()
  //   };

  //   // Optimistically update UI
  //   setMessages(prev => [...prev, newMessage]);
  //   setMessageInput("");

  //   // Send via socket
  //   sendMediaMessage({
  //     toUserId: activeUser.id,
  //     roomId,
  //     message: messageInput.trim()
  //   });

  //   // Scroll to bottom
  //   setTimeout(() => {
  //     if (bottomRef.current) {
  //       bottomRef.current.scrollIntoView({ behavior: 'smooth' });
  //     }
  //   }, 100);
  // };

  // Replace your current handleSendMessage with this version
const handleSendMessage = (e) => {
  e.preventDefault();
  
  if (!messageInput.trim() || !activeUser || !profile?.id) return;

  const roomId = generateMediaRoomId({ 
    patientId: profile.id, 
    doctorId: activeUser.id 
  });

  // Optimistically update UI
  const newMessage = {
    message: messageInput.trim(),
    from: profile.id,
    to: activeUser.id,
    timestamp: new Date().toISOString()
  };
  
  setMessages(prev => [...prev, newMessage]);
  setMessageInput("");

  // Send via socket. senderType is REQUIRED — the media server rejects any
  // private-message without a valid senderType (patient/doctor/agent).
  sendMediaMessage({
    toUserId: activeUser.id,
    roomId,
    message: messageInput.trim(),
    fromUserId: JSON.stringify(profile?.id),
    senderType: "patient",
  });

  // Scroll to bottom
  setTimeout(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, 100);
};

  // Video call handlers
  const startVideoCall = () => {
    setCallStatus("calling");
    setShowVideoModal(true);
    setCallStartTime(Date.now());
    
    // TODO: Implement actual call initiation
  };

  const endVideoCall = () => {
    setCallStatus("ended");
    // setTimeout(() => {
    //   setShowVideoModal(false);
    //   setCallStartTime(null);
    // }, 1000);
  };

  // Format message time
  const formatMessageTime = (timestamp) => {
    const now = moment();
    const msgTime = moment(timestamp);

    if (now.diff(msgTime, 'days') === 0) {
      return msgTime.format('h:mm A');
    } else if (now.diff(msgTime, 'days') === 1) {
      return `Yesterday ${msgTime.format('h:mm A')}`;
    }
    return msgTime.format('MMM DD, h:mm A');
  };

  // Format call duration
  const formatCallDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const uniqueRecentChats = Array.from(
    new Map(recentChats.map(chat => [chat.id, chat])).values()
  );

  console.log(uniqueRecentChats,"recentChats---------------")
  return (
    <React.Fragment>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <div className={`chat-panel ${showChat ? "msg-show" : ""}`}>
          {/* Chat sidebar */}
          <div className="chat-sidebar">
            <div className="sidebar-header">
              <h6 className="sidebar-title me-auto">Contacts</h6>
              <Dropdown align="end">
                <Dropdown.Toggle as={CustomToggle}>
                  <i className="ri-more-2-fill"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item href=""><i className="ri-user-add-line"></i> New Contact</Dropdown.Item>
                  <Dropdown.Item href=""><i className="ri-settings-3-line"></i> Settings</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Link className="header-link ms-1" title="New message">
                <i className="ri-chat-new-line"></i>
              </Link>
            </div>

            <PerfectScrollbar className="sidebar-body">
              <label className="sidebar-label mb-2">Recent Chats</label>
              <div className="chat-group">
                {uniqueRecentChats.map((chat) => (
                  <div 
                    key={chat.id}
                    className={`chat-item ${activeUser?.id === chat.id ? "selected" : ""}`}
                    onClick={() => handleUserSelect({
                      id: chat.id,
                      name: patientname(chat.doctor),
                      avatar: parseAvatar(chat.doctor?.profile_pic),
                      status: "online", // You might want to track actual online status
                      lastSeen: "Active now",
                      lastMessage: chat.lastMessage
                    })}
                  >
                    <Avatar status={chat.status} img={parseAvatar(chat.doctor?.profile_pic)} />
                    <div className="chat-item-body">
                      <div className="d-flex align-items-center mb-1">
                        <h6 className="mb-0">{patientname(chat.doctor)}</h6>
                        {/* <small className="ms-auto">
                          {moment(chat.timestamp).format('YYYY MMM Do, hh:mm A')}
                        </small> */}
                        <small className="ms-auto">
                        {moment().diff(moment(chat.timestamp), 'days') < 1
                          ? moment(chat.timestamp).fromNow()
                          : moment(chat.timestamp).format('YYYY MMM Do, hh:mm A')}
                      </small>

                      </div>
                      <span>{chat.lastMessage}</span>
                      {chat.unreadCount > 0 && (
                        <span className="unread-badge">{chat.unreadCount}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </PerfectScrollbar>
          </div>

          {/* Chat body */}
          <div className="chat-body">
            {activeUser ? (
              <>
                <div className="chat-body-header">
                  <div className="chat-item">
                    <Avatar img={activeUser.avatar} status={activeUser.status} />
                    <div className="chat-item-body">
                      <h6 className="mb-1">{activeUser.name}</h6>
                      <span>{activeUser.status === "online" ? "Active now" : `Last seen ${activeUser.lastSeen}`}</span>
                      {isTyping && <small className="text-muted">typing...</small>}
                    </div>
                  </div>
                  {/* <Nav className="nav-icon ms-auto" style={{width: "90px"}}>
                    <Nav.Link title="Call" onClick={startVideoCall}>
                      <i className="ri-phone-line"></i>
                    </Nav.Link>
                    <Nav.Link title="Video Call" onClick={startVideoCall}>
                      <i className="ri-vidicon-line"></i>
                    </Nav.Link>
                    <Nav.Link className="d-md-none" onClick={() => setShowChat(false)}>
                      <i className="ri-close-fill"></i>
                    </Nav.Link>
                  </Nav> */}
                </div>

                <PerfectScrollbar className="chat-body-content">
                  {loadingMessages ? (
                    <div className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    messages.map((msg, index) => {
                      const isSelf = msg.from == profile?.id;
                      const showTime = index === 0 || 
                        moment(msg.timestamp).diff(moment(messages[index - 1]?.timestamp), 'minutes') > 5;

                      return (
                        <React.Fragment key={index}>
                          {showTime && (
                            <div className="message-time-separator">
                              <small>{formatMessageTime(msg.timestamp)}</small>
                            </div>
                          )}
                          <div className={`msg-item ${isSelf ? "reverse" : ""}`}>
                            {!isSelf && <Avatar status={activeUser.status} img={activeUser.avatar} />}
                            <div className="msg-bod">
                              <div className="msg-bubble">
                                {msg.message}
                                <span>{moment(msg.timestamp).format('h:mm A')}</span>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })
                  )}
                  <div ref={bottomRef} />
                </PerfectScrollbar>

                <Form onSubmit={handleSendMessage} className="chat-body-footer" style={{ height: 'auto', minHeight: '60px', padding: '10px 15px' }}>
                  <Form.Control 
                    as="textarea"
                    rows={1}
                    name="message"
                    placeholder="Type your message... (Shift + Enter for new line)" 
                    value={messageInput}
                    onChange={(e) => setMessageInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        handleSendMessage(e);
                      }
                    }}
                    style={{
                      resize: 'none',
                      minHeight: '40px',
                      maxHeight: '120px',
                      lineHeight: '1.4',
                      paddingTop: '8px',
                      paddingBottom: '8px',
                    }}
                  />
                  <Button 
                    type="submit" 
                    variant="link" 
                    className="msg-send"
                    disabled={!messageInput.trim()}
                  >
                    <i className="ri-send-plane-2-line"></i>
                  </Button>
                </Form>
              </>
            ) : (
              <div className="chat-body-empty h-100 w-100">
                <div className="empty-state h-100 w-100 d-flex flex-column align-items-center justify-content-center">
                  <div className="empty-state-icon">
                    <i className="ri-chat-3-line text-success"></i>
                  </div>
                  <h5>Select a conversation</h5>
                  <p>Choose a contact to start chatting</p>
                </div>
              </div>
            )}
          </div>
        </div>

        

        <Footer />
      </div>
    </React.Fragment>
  );
};

// CustomToggle component
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <Link
    to=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className="header-link"
  >
    {children}
  </Link>
));

export default Chat;


